import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import withModal from '../../../lib/hoc/withModal';
import ExcelBulkGeneratePointModal from '../../../views/point/common/modal/ExcelBulkGeneratePointModal';
import { pointActions } from '../../../store/modules/point';
import { POINT_ACTIONS_NAME } from '../../../constants/service/app/pointConstants';

class ExcelBulkGeneratePointModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };
  }

  /**
   *  포인트 일괄 발급하기
   */
  onSubmit = () => {
    const { excelBulkGeneratePointCheck } = this.props;
    const { file } = this.state;

    if (!file) {
      message.error('업로드할 파일을 선택해 주세요.');
      return;
    }

    excelBulkGeneratePointCheck({
      targetAction: {
        name: POINT_ACTIONS_NAME,
        ...pointActions,
      },
      attachment: [file],
    });

    /**
     * 모달 닫기
     */
    this.closeModal();
  };

  /**
   * 엑셀 파일 변경시 callback
   */
  onChange = (file) => {
    this.setState({
      file,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'excelBulkGeneratePointModal', value: false });
  };

  render() {
    const { isOpen } = this.props;
    const { file } = this.state;

    return (
      <ExcelBulkGeneratePointModal
        isOpen={isOpen}
        file={file}
        onSubmit={this.onSubmit}
        onChange={this.onChange}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.point.excelBulkGeneratePointModal.isOpen,
    data: state.point.excelBulkGeneratePointModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: pointActions.toggleModal,
  excelBulkGeneratePointCheck: pointActions.excelBulkGeneratePointCheck,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExcelBulkGeneratePointModalContainer));
